function variantSelector(){
    const SELECTOR_VARIANT = ".js_variant-container";
    const variantContainers = window.document.querySelectorAll(SELECTOR_VARIANT);

    if(variantContainers.length < 1) return;

    variantContainers.forEach(container => {
        const originalSelectId = container.getAttribute("data-option-select-id");
        const mainContainerId = container.getAttribute("data-varian-options-container-id");
        const originalSelect = window.document.getElementById(originalSelectId) || container.querySelector('.hidden-variant-selector');
        const options = window.document.getElementById(mainContainerId)?.querySelectorAll('.option-wrapper') || container.querySelectorAll('.option-wrapper');
        
        const selectedColor = container.parentElement?.querySelector('#selectedColor');
        const inputGcolor = window.document.getElementById('mixed-color-container');
        const submitBtn = window.document.getElementById("disabled-add-button");
        const buttonContainer = submitBtn?.parentElement;

        if(!originalSelect || options.length < 1) return;
        
        if( selectedColor){
            selectedColor.innerHTML = originalSelect.value;
        }

        if(inputGcolor && originalSelect.value.toLowerCase().indexOf("mixed") !== -1){
            buttonContainer?.classList.add('invalid-form');
            inputGcolor.style.maxHeight = inputGcolor?.scrollHeight + "px";
        }

        options.forEach(option => {
            option.addEventListener('click',function (){
                options.forEach(opt => {
                    if(opt !== this) opt.classList.remove('selected');
                })
                this.classList.add('selected');
                const value = this.getAttribute('data-option-value');
                const variant = this.getAttribute('data-option-variant');

                // Gestisco Mixed Color
                if( variant.toLowerCase().indexOf('color') !== -1){
                    selectedColor.innerHTML = value;
                    if (inputGcolor && value.toLowerCase().indexOf('mixed') !== -1 ) {
                        buttonContainer.classList.add('invalid-form');
                        inputGcolor.style.maxHeight = inputGcolor?.scrollHeight + "px";
                    }
                    else {
                        buttonContainer.classList.remove('invalid-form');
                        inputGcolor.style.maxHeight = null;
                    }
                }

                Array.from(originalSelect.options).forEach(opt => {
                    if(opt.value === value){
                        originalSelect.value = value;
                        originalSelect.dispatchEvent(new Event('change',{ bubbles: true, cancelable: false}));
                    }
                })
            });
        })
    });
}

function gColorInput(){
    const input = window.document.getElementById('mixed-color-input');
    const container = window.document.getElementById('mixed-color-container');
    const submitBtn = window.document.getElementById("disabled-add-button");
    const buttonContainer = submitBtn?.parentElement;

    if (!container || !input) return;

    input.addEventListener('keydown',function(e){
        const { value } = e.target;
        const { key } = e;
        
        if(!(key === "Backspace" || key === "Delete" || key === "ArrowLeft" || key === "ArrowRight" || key === "Tab")){
            if (value.length > 3 || !/[0-9]/.test(key)) 
                e.preventDefault(); 
        }
    });
    input.addEventListener('keyup',function(e){
        const {value} = e.target;
        if (value.length === 4) buttonContainer?.classList.remove('invalid-form');
        else buttonContainer?.classList.add('invalid-form');
    });

}

window.addEventListener('load',variantSelector);
window.addEventListener('load',gColorInput);